import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CustomFilterItem = _resolveComponent("CustomFilterItem");
  const _component_SelectedSection = _resolveComponent("SelectedSection");
  const _component_ListSection = _resolveComponent("ListSection");
  const _component_WrapWithDropdownBody = _resolveComponent("WrapWithDropdownBody");
  return _openBlock(), _createBlock(_component_WrapWithDropdownBody, {
    keyword: $props.keyword,
    searchPlaceholder: $props.search_placeholder,
    debounce: false,
    onHidden: _cache[6] || (_cache[6] = $event => _ctx.$emit('hidden')),
    onSearch: _cache[7] || (_cache[7] = val => _ctx.$emit('search', val)),
    onRestoreSearch: _cache[8] || (_cache[8] = $event => _ctx.$emit('restoreSearch'))
  }, {
    selected: _withCtx(() => [_createVNode(_component_SelectedSection, {
      title: $props.title,
      count: $props.selected.length,
      isModified: $props.isModified,
      onClear: _cache[1] || (_cache[1] = $event => {
        _ctx.$emit('clear');
      }),
      onApply: _cache[2] || (_cache[2] = $event => _ctx.$emit('apply')),
      onCloseDropdown: _cache[3] || (_cache[3] = $event => _ctx.$emit('closeDropdown'))
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.selected, item => {
        return _openBlock(), _createBlock(_component_CustomFilterItem, {
          key: item?.[`${$props.item_key}`],
          item_name: item?.[`${$props.item_name}`],
          item_name_key: $props.item_name,
          item_id_key: $props.item_key,
          item_id: item?.[`${$props.item_key}`],
          query: $props.keyword,
          selected: "",
          onDeselect: _cache[0] || (_cache[0] = val => _ctx.$emit('deselect', val))
        }, null, 8, ["item_name", "item_name_key", "item_id_key", "item_id", "query"]);
      }), 128))]),
      _: 1
    }, 8, ["title", "count", "isModified"])]),
    list: _withCtx(() => [_createVNode(_component_ListSection, {
      title: $props.title,
      count: $props.list.length,
      searching: $props.isSearching,
      keyword: $props.keyword
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, item => {
        return _openBlock(), _createBlock(_component_CustomFilterItem, {
          key: item?.[`${$props.item_key}`],
          item_name: item?.[`${$props.item_name}`],
          item_id: item?.[`${$props.item_key}`],
          item_name_key: $props.item_name,
          item_id_key: $props.item_key,
          query: $props.keyword,
          onSelect: _cache[4] || (_cache[4] = val => _ctx.$emit('select', val)),
          onSelectOnly: _cache[5] || (_cache[5] = val => _ctx.$emit('selectOnly', val))
        }, null, 8, ["item_name", "item_id", "item_name_key", "item_id_key", "query"]);
      }), 128))]),
      _: 1
    }, 8, ["title", "count", "searching", "keyword"])]),
    _: 1
  }, 8, ["keyword", "searchPlaceholder"]);
}